import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "@/lib/assets";

const TESTIMONIALS = [
  {
    name: "Léa",
    role: "Maman de Léon, 8 mois",
    city: "Lyon",
    quote:
      "En quelques jours j'ai échangé avec deux mamans du quartier. C'était naturel, dès le premier message.",
    img: ASSETS.testimonials[0],
  },
  {
    name: "Amina",
    role: "En post-partum",
    city: "Paris 15e",
    quote:
      "Discuter avec d'autres mamans qui vivaient exactement la même étape m'a fait un bien fou. Je ne me sens plus seule.",
    img: ASSETS.testimonials[1],
  },
  {
    name: "Clémence",
    role: "Maman de deux",
    city: "Bordeaux",
    quote:
      "L'interface est claire et douce. J'ai déjà organisé un café mamans grâce à MamaMatch — ça change ma semaine.",
    img: ASSETS.testimonials[2],
  },
];

const EASE = [0.2, 0.7, 0.2, 1];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-20 md:py-32 bg-white"
    >
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <div className="max-w-[720px] mb-12 md:mb-16">
          <p className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#D97757]">
            Elles utilisent MamaMatch
          </p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE }}
            className="mt-4 font-display text-[32px] sm:text-[42px] md:text-[52px] text-[#0A0A0A]"
          >
            De vraies mamans, de vrais liens.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, ease: EASE, delay: i * 0.08 }}
              className="mm-card p-7 md:p-9 flex flex-col"
            >
              <blockquote className="font-display text-[18px] md:text-[20px] leading-[1.35] text-[#0A0A0A] flex-1">
                « {t.quote} »
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-[rgba(10,10,10,0.08)] flex items-center gap-3">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-[#F7F5F2]">
                  <img
                    src={t.img}
                    alt={`Portrait de ${t.name}`}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-[15px] font-semibold text-[#0A0A0A]">
                    {t.name}
                  </div>
                  <div className="text-[13px] text-[#6B6660]">
                    {t.role} · {t.city}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
